import { Action } from 'redux'
import { SynchronizeActions } from '../../reducers/synchronize/actionNames'

export default function(): Action {
  return {
    type: SynchronizeActions.ReloadApp,
  }
}
